import axios from '@/modules/axiosInterceptor';
import { apiUrlPrefix } from '@/modules/staticData';

export default {
  mixins: [apiUrlPrefix],
  methods: {
    deleteUser(userObj) {
      const uid = userObj.id;
      const deferred = new Promise((resolve, reject) => {
        this.$root.$emit('modal-show-confirmation', {
          title: userObj.name,
          body: 'Delete the user permanently?',
          cbConfirm: () => {
            this.formLoading = true;
            axios.delete(`${apiUrlPrefix}users/${uid}`)
              .then(() => {
                this.$root.$emit('notification-add', { content: 'User deleted.' });
                resolve();
              })
              .catch(() => {
                this.$root.$emit('notification-add', { content: 'Unable to delete the user. Please try again.', variant: 'danger' });
                reject();
              })
              .finally(() => { this.formLoading = false; });
          },
          confirmText: 'Delete',
          cancelText: 'Cancel',
        });
      });
      return deferred;
    },
    updateUser(userObj) {
      this.formLoading = true;
      const deferred = new Promise((resolve, reject) => {
        axios.put(`${apiUrlPrefix}users`, { ...userObj }).then((r) => {
          this.$root.$emit('notification-add', { content: 'User updated.' });
          resolve(r.data.user);
        }).catch((r) => {
          this.handleFormErrors(r.response.data);
          reject();
        }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    createUser(userObj) {
      this.formLoading = true;
      const deferred = new Promise((resolve, reject) => {
        axios.post(`${apiUrlPrefix}users`, { ...userObj }).then((r) => {
          this.$root.$emit('notification-add', { content: 'User created.' });
          this.$router.push({ name: 'showUser', params: { id: r.data.user.id, userObj: r.data.user } });
          resolve(r.data.user);
        }).catch((r) => {
          this.handleFormErrors(r.response.data);
          reject();
        }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
  },
};
